module.exports = __webpack_public_path__ + "static/media/dollar(filled).44587c0b.svg";